import React, { useEffect, useState } from 'react'
import { blueColour, goldColour } from '../pages/Home'
import T from '../components/Translation'
import { dT } from '../components/Translation'
import TrueFalseToggle from '../whitaijiFrontendLibrary/components/TrueFalseToggle'
import RichTextEditor from '../whitaijiFrontendLibrary/textEditors/RichTextEditor'
import { keyId } from '../whitaijiFrontendLibrary/lib/utils';
import BlueButton from '../components/BlueButton'
import { useStateContext } from '../context/StateContext'
import { useAuthContext } from '../whitaijiFrontendLibrary/auth/hooks/useAuthContext'
import { AuthContext } from '../context/AuthContext'
import { useMutation } from '@tanstack/react-query'
import { _CREATE } from '../utils/patches'
import VisDiv from '../whitaijiFrontendLibrary/components/VisDiv'
import { runFireworks } from '../components/Fireworks'

const Feedback = () => {
    const [bug, setBug] = useState(false)
    const [improvement, setImprovement] = useState(false)
    const {language, apiUrl, hideTestButtons} = useStateContext() 
    const {user} = useAuthContext(AuthContext)
    const [existingRichDoc, setExistingRichDoc] = useState({})
    const [feedback, setDescription] = useState(null)
    const [error, setError] = useState(null)
    const [submitted, setSubmitted] = useState(false)

    const doc = {
        bug,
        improvement,
        feedback
    }

useEffect(() => {
    if(submitted) {
        runFireworks()
    }
}, [submitted])
const { mutate: submitFeedback } = useMutation({
    mutationFn: async(doc) => {
      process.env.NODE_ENV === "development" && console.log('Feedback, Calling:', doc);
      return await _CREATE({
        route: `${apiUrl}/feedback`, 
        doc: doc, 
        user, 
        onSuccess: (data) => {
            setSubmitted(true)
        }, 
        //onError
      });
    },
    //onSettled: () => queryClient.invalidateQueries({ queryKey: ['logConcertInProgress'] }),
    //mutationKey: ['logConcertInProgress'],
  });
      const editorDoc = (data) => {
        const newValue = { ...data, blocks: data?.blocks?.map((x) => ({ ...x, _key: keyId() })) };
        setDescription(newValue);
      };
    const update = (value) => {
    //setLaws([...filteredArray, value])
      if(!feedback) {
            setError(dT({en:"Please fill the feedback", it:"per favore scrivi il feedback"}, language))
            return 
        }
    if(feedback?.blocks?.length === 1 && !feedback.blocks[0].text) {
            setError(dT({en:"Please fill the feedback", it:"per favore scrivi il feedback"}, language))
            return 
    }
        if(feedback?.blocks?.every((x) => !x.text)) {
            setError(dT({en:"Please fill the feedback", it:"per favore scrivi il feedback"}, language))
            return 
    }
    setError(null)

    submitFeedback(value)
}   
  return (
    <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
        <VisDiv rules={[!submitted]} style={{ textAlign:"center", backgroundColor:goldColour, width:"80%", margin:"10px", padding:"30px", borderRadius:"10px", }}>
            <div>
                <h2>
                    <T obj={{en:"Your feedback is much appreciated!", it:""}}/>
                </h2>
            </div>
            <TrueFalseToggle
                label = {<T obj={{en:"Report a software bug", it:"reporta un bug del software"}}/>}
                onClick={() => setBug(!bug)}
                value={bug}
            />
            <TrueFalseToggle
                label = {<T obj={{en:"Report an improvement", it:"reporta un miglioramento"}}/>}
                onClick={() => setImprovement(!improvement)}
                value={improvement}
            />
            <div style={{padding:"10px", marginTop:"20px", backgroundColor:"white", borderRadius:"10px"}}>
                <RichTextEditor 
                    onChange={(e) => setDescription(e.target.value)}
                    noFocus={true}
                    editorDoc={editorDoc}
                    updateInitialData={true}
                    fullWidth={true}
                    //onBlur={()=>update(doc)} 
                    existingDoc={existingRichDoc} 
                />
            </div>
             {error && <div style={{color: 'red', margin:"10px 0px 10px 0px"}}>{error}</div>}
            <div>
                <BlueButton hoverColor={blueColour} color="green" text={""} fn={() => update(doc)}><T obj={{en:"Submit", it:"Invia"}}/></BlueButton>
            </div>
        </VisDiv>
        <VisDiv style={{ textAlign:"center", backgroundColor:goldColour, width:"80%", margin:"10px", padding:"30px", borderRadius:"10px", }} rules={[submitted]}>
            <h2>
                <T obj={{en:"Thanks for your feedback!", it:"Grazie per il tuo feedback!"}}/>
            </h2>
             <BlueButton home />
        </VisDiv>
    </div>
  )
}

export default Feedback
